export default "__VITE_ASSET__ew1fOuzQ__"